import { createAction } from 'redux-act'

const fetchIAFLabelsStart = createAction('Fetch IAF Labels - Start')
const fetchIAFLabelsSuccess = createAction('Fetch IAF Labels - Success')
const fetchIAFLabelsFail = createAction('Fetch IAF Labels - Fail')

export default {
  fetchIAFLabelsStart,
  fetchIAFLabelsSuccess,
  fetchIAFLabelsFail,
}
